<template>
  <div class="wrapp-invoice">
    <b-form-group id="groupisInvoiceRequired" label-for="isInvoiceRequired">
      <base-check-box
        name="isInvoiceRequired"
        :use_prevent="false"
        :disabled="invoiceDisabled"
        v-model="invoiceActive"
        :label="$t('invoice.require-invoice')"
      >
      </base-check-box>
    </b-form-group>
    <template v-if="invoiceActive">
      <div class="wrapp-invoices">
        <b-form-group label-for="invoice-type">
          <base-select
            selectClass="select-shadowed"
            name="invoice-type"
            v-model="invoice.type"
            :options="invoiceTypes"
            :clearable="false"
            :reduce="(opt) => opt.value"
            :selectable="(opt) => !opt.disabled"
            @input="typeChange"
          >
          </base-select>
        </b-form-group>
        <component :is="invoice.type" v-model="invoice" v-validate="'required'" name="invoice" />
      </div>
    </template>
  </div>
</template>

<script>
import BaseSelect from 'theme/components/Form/BaseSelect'
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'
import BaseInput from 'theme/components/Form/BaseInput'
import Private from 'theme/components/Checkout/Invoice/Form/Private.vue'
import { DefaultInvoice } from '@/store/modules/checkout/defaultValues'

export default {
  name: 'Invoice',
  $_veeValidate: {
    value () {
      return this.invoice
    },
    name () {
      return 'invoice'
    }
  },
  props: {
    sameAsShipping: {
      type: Boolean,
      default: true
    },
    billingAddress: {
      type: Object,
      default: () => {}
    },
    shippingAddress: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      invoiceActive: false,
      invoice: { ...DefaultInvoice },
      invoiceTypes: [
        {
          label: this.$t('invoice.type.private'),
          value: 'private',
          disabled: false
        },
        {
          label: this.$t('invoice.type.company'),
          value: 'company',
          disabled: true
        },
        {
          label: this.$t('invoice.type.association'),
          value: 'association',
          disabled: true
        }
      ]
    }
  },
  computed: {
    invoiceDisabled () {
      // disable if country if != from IT
      // this means that user want to ship abroad
      let address = this.sameAsShipping ? this.billingAddress : this.shippingAddress
      if (address && address.country_id) {
        return address.country_id !== 'IT'
      } else {
        return false
      }
    }
  },
  methods: {
    init () {
      // check if invoice is setted on cart
      // if yes enable it
      this.invoiceActive = Object.values(this.$store.state.checkout.invoice).filter((val) => val).length > 1
      this.invoice = { ...this.$store.state.checkout.invoice }
    },
    typeChange () {
      // reset invoices
      this.invoice.vat_id = ''
      this.invoice.recipient = ''
      this.invoice.fiscalcode = ''
      this.invoice.heading = ''
      this.invoice.pec = ''
    },
    handleSubmit () {
      const _this = this
      return this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (!this.invoiceActive) {
            // store invoice as plain
            _this.$store.commit('checkout/setInvoice', DefaultInvoice)
          } else {
            _this.$store.commit('checkout/setInvoice', _this.invoice)
          }
          return isValid
        }
        return false
      })
    }
  },
  watch: {
    invoiceDisabled (newValue) {
      this.invoiceActive = newValue
    }
  },
  components: {
    BaseInput,
    BaseCheckBox,
    BaseSelect,
    Private
  }
}
</script>
